import React from 'react';
import { Container, Typography, Box, Button } from '@mui/material';
import { ArrowBack } from '@mui/icons-material';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';

const Impressum = () => {
  return (
    <Box
      sx={{
        minHeight: '100vh',
        bgcolor: '#000',
        py: 8,
      }}
    >
      <Container maxWidth="md">
        <motion.div
          initial={{ opacity: 0, y: 50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >
          <Button
            component={Link}
            to="/"
            startIcon={<ArrowBack />}
            sx={{
              mb: 4,
              color: 'white',
              '&:hover': {
                bgcolor: 'rgba(255, 255, 255, 0.1)',
              },
            }}
          >
            Zurück zur Hauptseite
          </Button>

          <Typography
            variant="h2"
            sx={{
              mb: 4,
              fontWeight: 600,
              color: 'white',
            }}
          >
            Impressum
          </Typography>

          <Box
            sx={{
              bgcolor: 'rgba(255, 255, 255, 0.05)',
              backdropFilter: 'blur(10px)',
              border: '1px solid rgba(255, 255, 255, 0.1)',
              borderRadius: 3,
              p: 4,
              mb: 4,
            }}
          >
            <Typography
              variant="h5"
              sx={{
                mb: 2,
                fontWeight: 600,
                color: 'white',
              }}
            >
              Angaben gemäß § 5 TMG
            </Typography>

            <Typography
              variant="body1"
              sx={{
                color: 'rgba(255, 255, 255, 0.8)',
                lineHeight: 1.6,
                mb: 3,
              }}
            >
              MJ Webagentur<br />
              Bauerstraße 38<br />
              80796 München<br />
              Deutschland
            </Typography>

            <Typography
              variant="h6"
              sx={{
                mb: 1,
                fontWeight: 600,
                color: 'white',
              }}
            >
              Kontakt
            </Typography>
            <Typography
              variant="body1"
              sx={{
                color: 'rgba(255, 255, 255, 0.8)',
                lineHeight: 1.6,
                mb: 3,
              }}
            >
              Telefon: +49 123 456 789<br />
              E-Mail: info@mj-webagentur.de
            </Typography>

            <Typography
              variant="h6"
              sx={{
                mb: 1,
                fontWeight: 600,
                color: 'white',
              }}
            >
              Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV
            </Typography>
            <Typography
              variant="body1"
              sx={{
                color: 'rgba(255, 255, 255, 0.8)',
                lineHeight: 1.6,
                mb: 3,
              }}
            >
              MJ Webagentur<br />
              Bauerstraße 38<br />
              80796 München<br />
              Deutschland
            </Typography>

            <Typography
              variant="h6"
              sx={{
                mb: 1,
                fontWeight: 600,
                color: 'white',
              }}
            >
              Haftungsausschluss
            </Typography>
            <Typography
              variant="body1"
              sx={{
                color: 'rgba(255, 255, 255, 0.8)',
                lineHeight: 1.6,
                mb: 2,
              }}
            >
              <strong>Haftung für Inhalte</strong><br />
              Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir als Diensteanbieter jedoch nicht unter der Verpflichtung, übermittelte oder gespeicherte fremde Informationen zu überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige Tätigkeit hinweisen.
            </Typography>

            <Typography
              variant="body1"
              sx={{
                color: 'rgba(255, 255, 255, 0.8)',
                lineHeight: 1.6,
                mb: 2,
              }}
            >
              <strong>Haftung für Links</strong><br />
              Unser Angebot enthält Links zu externen Websites Dritter, auf deren Inhalte wir keinen Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen. Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich.
            </Typography>

            <Typography
              variant="body1"
              sx={{
                color: 'rgba(255, 255, 255, 0.8)',
                lineHeight: 1.6,
              }}
            >
              <strong>Urheberrecht</strong><br />
              Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers.
            </Typography>
          </Box>
        </motion.div>
      </Container>
    </Box>
  );
};

export default Impressum;